import React from 'react'

const DefaultLoading = () => {

    return (

        <div className="spinner"></div>

    )
}

export default DefaultLoading